var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEsm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9V2.40062C0 1.0748 1.07479 0 2.40062 0C3.72644 0 4.80123 1.07479 4.80123 2.40062V5.69434C4.80123 9.83892 8.16108 13.1988 12.3057 13.1988H15.5994C16.9252 13.1988 18 14.2736 18 15.5994C18 16.9252 16.9252 18 15.5994 18H8.99999C4.02944 18 0 13.9706 0 9ZM15.6054 4.78929C14.2829 4.78929 13.2107 3.71717 13.2107 2.39464C13.2107 1.07212 14.2829 0 15.6054 0C16.9279 0 18 1.07212 18 2.39464C18 3.71717 16.9279 4.78929 15.6054 4.78929ZM6.61139 5.69433V2.39464C6.61139 1.07212 7.68351 0 9.00603 0C10.3286 0 11.4007 1.07212 11.4007 2.39464C11.4007 4.71686 13.2832 6.59939 15.6054 6.59939C16.9279 6.59939 18 7.6715 18 8.99403C18 10.3166 16.9279 11.3887 15.6054 11.3887H12.3057C9.16083 11.3887 6.61139 8.83923 6.61139 5.69433Z",
    fill: "#001C00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEsm);
export default __webpack_public_path__ + "static/media/icon-esm.87ac63d8.svg";
export { ForwardRef as ReactComponent };